<script setup>
import { computed } from 'vue'

const props = defineProps({
    title: {
        type: String,
        default: '',
    },
    open: {
        type: Boolean,
        default: false,
    },
})

const emits = defineEmits(['close'])

const show = computed({
    get() {
        return props.open
    },
    set() {
        onClose()
    },
})

const onClose = () => {
    emits('close')
}
</script>

<template>
    <Teleport to="#main-container">
        <v-navigation-drawer
            :scrim="false"
            temporary
            location="right"
            v-model="show"
        >
            <div class="flex flex-col h-full">
                <div class="flex items-center p-3 border-b border-edge">
                    <button class="mr-2" @click.prevent="onClose">
                        <v-icon icon="fas fa-arrow-left" />
                    </button>
                    <v-list-item
                        data-test="ag-panel-title"
                        class="font-semibold"
                        :title="title"
                    ></v-list-item>
                </div>

                <v-divider></v-divider>
                <div
                    id="ag-grid-custom-panel"
                    class="ag-panel-content w-full ag-theme-alpine ag-theme-bolt relative overflow-scroll"
                ></div>
            </div>
        </v-navigation-drawer>
    </Teleport>
</template>
<style lang="scss">
.ag-tool-panel-wrapper {
    width: 100%;
}

.ag-side-buttons {
    display: none !important;
}

.ag-text-field-input-wrapper {
    @apply border rounded p-1 bg-white border-none;
}

.ag-text-field-input {
    @apply p-1;
}

.ag-filter-body-wrapper,
.ag-filter-toolpanel-instance,
.ag-group-item,
.ag-filter-apply-panel {
    @apply bg-white;
}

.ag-filter-apply-panel-button {
    @apply font-bold py-1 px-2 rounded bg-blue-500 text-white mr-1;
}

.ag-side-bar {
    @apply h-screen bg-white;
}

.ag-tool-panel-wrapper {
    @apply bg-white;
}

.ag-column-select-header {
    padding: 1.2rem;
}

.v-navigation-drawer > .v-navigation-drawer__content {
    overflow-y: hidden;
}
</style>
